import axios from "axios";

export async function uploadfiletodms(endpoint, configheaders) {
    try {
        let apiresults = await axios(endpoint, configheaders);
        let records = [];

        if (apiresults.data.issuccess) {
            records = apiresults.data;
        } else {

        }
        return records;
    } catch (err) {
        return err.response.data;
    }
}

export async function deletefilefromdms(endpoint, configheaders) {
    let apiresults = await axios(endpoint, configheaders);
    let records = [];

    if (apiresults.data.issuccess) {
        records = apiresults.data;
    } else {

    }
    return records;
}